import React, { Component } from 'react';
import { Route } from "react-router-dom";
import { _post, _getToken, variable, _Alert, _setTime, _isLogin } from './Function';
import SideBar from './SideBar';
import MessageAll from './Message.All';
import MessageDesc from './Message.Desc';
import '../css/MessageAll.css';

class Message extends Component {
    constructor() { 
        super();
    }

    onAddTime = () => { _setTime() }

    render() {
        return(
            <div className="fix-content content-bar-bigger" onClick={(e) => this.onAddTime()}>
                <Route exact path="/online/message" component={MessageAll} />
                <Route path="/online/message/:id" component={MessageDesc} />
            </div>
        )
    }
}

export default Message;